import { SubmitPaymentProofScreen } from '@/modules/payments/SubmitPaymentProofScreen';
import { Stack } from 'expo-router';
import React from 'react';

export default function PaymentProofSubmitRoute() {
    return (
        <>
            {/* iOS swipe-back would pop into the already-submitted payment flow.
                The header back, Android back and footer button all return to
                where Pay Now was opened from instead. */}
            <Stack.Screen options={{ gestureEnabled: false }} />
            <SubmitPaymentProofScreen />
        </>
    );
}
